import { useEffect, useState } from 'react';

import Resources from '@helpers/resources';

/**
 * USE EXPLICIT SERVICE REQUEST
 * ------------------------------
 * We are occasionally unable to use the resource manager. This hook holds gateway and auth data
 * to allow for custom, explicit service requests.
 */
const useExplicitServiceRequest = () => {
  /**
   * VARIABLES
   */
  const UPF_ASSIGN_GATEWAY = 'UpfAssignGateway';

  /**
   * STATE
   */
  const [gateway, setGateway] = useState(null);

  /**
   * FUNCTIONS
   */
  const manageGateway = async () => Resources.getConfigurationItem(UPF_ASSIGN_GATEWAY);

  const getExplicitRequestUrl = ({ urlPath }) => {
    const authToken = Resources.env.authToken;
    if (authToken && gateway) {
      return `${gateway}${urlPath}?authToken=${authToken}`;
    }
    return null;
  }

  /**
   * EFFECT
   */
  useEffect(() => {
    manageGateway()
      .then((updatedGateway) => setGateway(updatedGateway));
  }, []);

  return {
    getExplicitRequestUrl
  }
}

export default useExplicitServiceRequest;



// WEBPACK FOOTER //
// ./helpers/hooks/use-explicit-service-request.js